export const CURRENCY = "ريال";
export const TITLE = "رسوم الدفع والتوصيل";
export const TOTAL = "صافي المبلغ";
export const TABLE_ITEMS = {
  DELIVERY_FEES: "التوصيل",
  NET_PRICE: "التكلفة الرئيسية",
  SUB_TOTAL: "إجمالي التكلفة الفرعية",
};
export const DISCOUNT = "خصم";
export const CODE = "كود";
export const NO_DISCOUNT_MESSAGE = "لا يوجد خصم";

export const SUB_TOTAL = "التكلفة الكلية";
export const WAFFY_FEES = "رسوم خدمة وفي";
export const TABBY_FEES = "رسوم تابي";
export const DISCOUNT_AMOUNT = "الخصم";
